// ProtectedRoute.js
//
import { Route, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const history = useHistory();
  const { isLoggedIn } = useSelector((state) => state.authSliceReducer);

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? <Component {...props} /> : history.push("/")
      }
    />
  );
};

export default ProtectedRoute;
